import type { ReactNode } from 'react';
import { InfoHint } from '@/components/InfoHint';
import { cn } from '@/lib/cn';

interface PageHeaderProps {
  title: string;
  hint?: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

/** Page h1 (weight 400, owner decision 2) with optional info hint, subtitle and right-aligned actions. */
export function PageHeader({ title, hint, subtitle, actions, className }: PageHeaderProps): JSX.Element {
  return (
    <div className={cn('mb-6', className)}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-1.5">
          <h1 className="truncate text-2xl font-normal text-foreground">{title}</h1>
          {hint && <InfoHint text={hint} />}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
  );
}
